import { render, staticRenderFns } from "./catalogList.vue?vue&type=template&id=1f485058&scoped=true&"
import script from "./catalogList.vue?vue&type=script&lang=js&"
export * from "./catalogList.vue?vue&type=script&lang=js&"
import style0 from "./catalogList.vue?vue&type=style&index=0&id=1f485058&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f485058",
  null
  
)

export default component.exports